import { vservice } from '@niknevis/vue-modules'
import { AdminWalletLogService } from '@/modules/wallet-log/services/admin-wallet-log.service'
import { RemoteData } from '@/modules/shared/helpers/http/remote-data'
import { WalletLogCollectionType } from '@/modules/wallet-log/models/admin-wallet-log-collection.model'
import { isPlainObject } from '@/modules/shared/helpers/utils/utils'

@vservice()
export class AdminGetWalletLogUseCase {
  constructor(
    private readonly service: AdminWalletLogService
  ) {
  }

  private defaultData = { meta: { current_page: 1 }, data: [] }

  private remoteData = RemoteData.notAsked<WalletLogCollectionType>()

  get isLoading() {
    return this.remoteData.isInProgress()
  }

  get getLogs() {
    return this.remoteData.fold(
      () => this.defaultData,
      value => value || this.defaultData,
      value => value,
      (error, value) => value || this.defaultData
    )
  }

  cv(v) {
    return v
  }

  execute(userId: number, page: number, params?: Record<string, string | number | boolean>) {
    const _params = {
      ...(isPlainObject(params) ? params : {}),
      user: userId,
      page: page < 1 ? 1 : page
    }

    return this.remoteData.fromPromise(
      this.service.walletLogs(_params)
    )
  }
}
